import React from "react";
import { Facebook, Instagram } from "lucide-react";
import fb_cover  from "../../../assets/images/ahd_facebook_cover.jpg";
import ahd_logo  from "../../../assets/images/ahd_profile.png";
import "./SocialMedia.css";

const SocialMedia = () => (
  <section className="social">
    <div className="social__container">

      <div className="social__header">
        <span className="social__label">Stay connected</span>
        <h2 className="social__title">
          Follow us on <em>Social Media</em>
        </h2>
      </div>

      <div className="social__grid">

        {/* Facebook */}
        <div className="social__card">
          <div className="social__fb-cover">
            <img src={fb_cover} alt="All Home Desire Facebook cover" />
            <div className="social__fb-cover-overlay" />
          </div>
          <div className="social__fb-body">
            <div className="social__fb-profile">
              <img src={ahd_logo} alt="All Home Desire" className="social__fb-avatar" />
              <div>
                <p className="social__fb-name">All Home Desire</p>
                <p className="social__fb-followers">5.4K followers</p>
              </div>
            </div>
            <a
              href="https://www.facebook.com/allhomedesire/"
              target="_blank"
              rel="noopener noreferrer"
              className="social__fb-btn"
            >
              <Facebook size={16} strokeWidth={2.5} />
              Visit Facebook
            </a>
          </div>
        </div>

        {/* Instagram */}
        <div className="social__card">
          <div className="social__ig-top">
            <div className="social__ig-avatar-wrap">
              <img src={ahd_logo} alt="All Home Desire" className="social__ig-avatar" />
            </div>
            <div>
              <p className="social__ig-name">All Home Desiré</p>
              <p className="social__ig-handle">@allhomedesire</p>
            </div>
            <Instagram size={28} className="social__ig-icon" />
          </div>
          <div className="social__ig-body">
            <div className="social__ig-stats">
              <div className="social__ig-stat">
                <span className="social__ig-stat-number">4,477</span>
                <span className="social__ig-stat-label">Followers</span>
              </div>
              <div className="social__ig-stat">
                <span className="social__ig-stat-number">53</span>
                <span className="social__ig-stat-label">Posts</span>
              </div>
            </div>
            <a
              href="https://instagram.com/allhomedesire"
              target="_blank"
              rel="noopener noreferrer"
              className="social__ig-btn"
            >
              <Instagram size={16} />
              Visit Instagram
            </a>
          </div>
        </div>

      </div>
    </div>
  </section>
);

export default SocialMedia;